import Screen from "../../components/Screen";
import { useEffect } from "react";
import { routes } from "../../utils/routeHelper";
import { useLocation, useNavigate } from "react-router";

export default function MainPage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/") {
      navigate(routes.dashboard.get());
    }
  }, [pathname]);

  return (
    <Screen isAnimated>
      <h3>Redirecting ...</h3>
    </Screen>
  );
}
